export default __webpack_public_path__ + "static/media/maikeVile.df686610.svg";